import UrlSearchParams from 'url-search-params'
import sendPostMessage from './post-communication'
import constants from '../constants/index'
import { mappTrackingCookie } from '../services/cookies'

export const publishTracking = (customTracking) => {
  try {
    sendPostMessage({
      ...customTracking,
      ...constants.USER_ACTIONS.analytics,
      timestamp: Math.floor((new Date()).getTime() / 1000),
    })
  } catch (error) {
    console.log(error)  // eslint-disable-line no-console
  }
}

export const getMappTrackingParameters = () => {
  const urlParams = new UrlSearchParams(window.location.search)

  // query string has higher priority
  if (urlParams.has('platform')) {
    return mappTrackingCookie({
      platform: urlParams.get('platform') || '',
      element: urlParams.get('element') || '',
      referrer: urlParams.get('referrer') || '',
    })
  }

  return mappTrackingCookie()
}



// WEBPACK FOOTER //
// ./src/services/tracking.js